(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/redux-localstorage/assets/javascript/prescript.js') >= 0) return;  svs.modules.push('/components/app/redux-localstorage/assets/javascript/prescript.js');

'use strict';

svs = svs || {};
svs.app = svs.app || {};
svs.app.ReduxLocalStorage = svs.app.ReduxLocalStorage || {};


 })(window);